import { CompanyDocumentTreeNodeOptions } from "@/modules/documents/widgets/company-document-tree-node-options";
import { TreeNodeIcon } from "../tree-node-icon/tree-node-icon";
import { CompanyDocumentTreeDataNode } from "../../model/types";

export function TreeNodeTitle({
  node,
  canManage,
  expanded,
}: {
  node: CompanyDocumentTreeDataNode;
  canManage: boolean;
  expanded?: boolean;
}) {
  const raw = node.node;
  const { title } = node;

  return (
    <span className="flex w-full min-w-0 items-center justify-between gap-3 py-1 px-2">
      <span className="flex min-w-0 flex-1 items-center gap-3">
        <TreeNodeIcon
          node={raw}
          expanded={expanded}
          className="shrink-0 text-xl"
        />
        <span className="min-w-0 truncate text-base leading-6" title={title}>
          {title}
        </span>
      </span>

      {canManage && (
        <span
          className="flex shrink-0 items-center"
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <CompanyDocumentTreeNodeOptions node={raw} />
        </span>
      )}
    </span>
  );
}
